<div class="personal-wall"
  [class.personal-wall-ltr]="!isRTL"
  [class.personal-wall-dark]="isDarkMode">
  <div class="personal-wall-share-slot"
    [class.personal-wall-share-slot-collapsed]="isScrolledDown">
    <button type="button"
      class="personal-wall-share-btn"
      [matTooltip]="'wall.personal.to-exhibition' | translate"
      matTooltipPosition="below"
      matTooltipTouchGestures="off"
      [matTooltipDisabled]="!shareNavTooltipEnabled()"
      (click)="goToExhibition()">
      <mat-icon>favorite</mat-icon>
      <span>{{ 'wall.personal.to-exhibition' | translate }}</span>
    </button>
  </div>
  <div class="personal-wall-inner">
    <header class="personal-wall-header">
      <h1 class="personal-wall-title mb-0">{{ 'wall.personal.title' | translate }}</h1>
    </header>

    <div class="personal-wall-layout">
      <main class="personal-wall-main">
          <!-- Draft: new works from current order session -->
          <section *ngIf="worksTab !== 'profile' && (wallFiles.length || isDraftCollapsing)"
            class="personal-wall-panel personal-wall-draft"
            [class.personal-wall-draft-collapsing]="isDraftCollapsing"
            (transitionend)="onDraftCollapseEnd($event)">
            <h3 class="personal-wall-hint">
              <span class="personal-wall-works-tab-label">{{ 'wall.personal.works-hint' | translate }}</span>
              <span *ngIf="selectedWorksCount > 0" class="personal-wall-works-tab-count">{{ selectedWorksCount }}</span>
            </h3>

            <div class="personal-wall-draft-works"
              [class.personal-wall-draft-works-publishing]="isPublishing">
            <div *ngIf="isPublishing" class="personal-wall-draft-spinner" aria-hidden="true">
              <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
            </div>
            <div class="personal-wall-collage personal-wall-draft-grid">
              <article *ngFor="let file of wallFiles; trackBy: trackDraftById"
                class="personal-wall-card"
                [class.personal-wall-card-open]="file.included"
                [class.personal-wall-card-off]="!file.included">
                <div class="personal-wall-card-media"
                  [class.personal-wall-card-media-sized]="!!file.natW"
                  [class.is-loading]="!file.imgLoaded"
                  [style.--ar-w]="draftArW(file)"
                  [style.--ar-h]="draftArH(file)"
                  (click)="onDraftImageClick(file, $event)">
                  <div class="personal-wall-card-media-clip">
                    <img [src]="file.thumbUrl" [alt]="file.fileName"
                      class="personal-wall-card-img"
                      [class.personal-wall-card-img-sideways]="isSideways(file.rotation)"
                      [class.is-pending]="!file.imgLoaded"
                      [style.transform]="imageTransform(file.rotation)"
                      (load)="onWallImageLoad($event, file)"
                      (error)="onImageError($event, file)">
                  </div>
                  <div *ngIf="!file.imgLoaded" class="personal-wall-card-shimmer"></div>

                  <div class="personal-wall-card-overlay personal-wall-card-overlay-check"
                    (click)="$event.stopPropagation()">
                    <button type="button"
                      class="personal-wall-include-check"
                      [class.is-checked]="file.included"
                      (click)="onFileToggle(file, !file.included)"
                      [attr.aria-pressed]="file.included"
                      [attr.aria-label]="'wall.personal.works-hint' | translate">
                      <mat-icon *ngIf="file.included">check</mat-icon>
                    </button>
                  </div>
                </div>

                <div class="personal-wall-fold-clip" [class.is-open]="file.included">
                  <div class="personal-wall-fold">
                    <div class="personal-wall-work-panel">
                      <div class="personal-wall-edit-action-group">
                        <button type="button" class="personal-wall-edit-action"
                          (click)="rotateDraftClockwise(file, $event); $event.preventDefault()"
                          [attr.aria-label]="'wall.personal.rotate' | translate">
                          <mat-icon>rotate_right</mat-icon>
                          <span>{{ 'wall.personal.rotate' | translate }}</span>
                        </button>
                        <button type="button" class="personal-wall-edit-action"
                          [class.is-muted]="file.hiddenFromAudience"
                          (click)="toggleDraftHiddenFromAudience(file, $event); $event.preventDefault()"
                          [attr.aria-label]="(file.hiddenFromAudience ? 'wall.personal.show-to-audience' : 'wall.personal.hide-from-audience') | translate">
                          <mat-icon>{{ file.hiddenFromAudience ? 'visibility_off' : 'visibility' }}</mat-icon>
                          <span>{{ (file.hiddenFromAudience ? 'wall.personal.show-to-audience' : 'wall.personal.hide-from-audience') | translate }}</span>
                        </button>
                      </div>
                      <div class="personal-wall-card-name-row">
                        <div class="personal-wall-card-name opacity-50" [title]="file.fileName">
                          {{ truncateFileName(file.fileName) }}
                        </div>
                        <span *ngIf="file.pageCount > 1" class="personal-wall-page-of opacity-50">
                          {{ 'wall.personal.page-of' | translate: { n: file.page, total: file.pageCount } }}
                        </span>
                      </div>
                      <div class="personal-wall-edit-fields">
                        <div class="personal-wall-edit-field">
                          <label class="personal-wall-edit-field-label"
                            [attr.for]="'draft-title-' + file.id">
                            {{ 'wall.personal.work-title' | translate }}
                          </label>
                          <mat-form-field appearance="outline" subscriptSizing="dynamic"
                            class="w-100 eazix-exhibition-comment-field personal-wall-edit-comment-field">
                            <textarea matInput rows="1" [(ngModel)]="file.title"
                              [id]="'draft-title-' + file.id"
                              [placeholder]="'wall.personal.work-title-placeholder' | translate"
                              (input)="resizeWorkField($event)"></textarea>
                          </mat-form-field>
                        </div>
                        <div class="personal-wall-edit-field">
                          <label class="personal-wall-edit-field-label"
                            [attr.for]="'draft-desc-' + file.id">
                            {{ 'wall.personal.work-description' | translate }}
                          </label>
                          <mat-form-field appearance="outline" subscriptSizing="dynamic"
                            class="w-100 eazix-exhibition-comment-field personal-wall-edit-comment-field">
                            <textarea matInput rows="2" [(ngModel)]="file.description"
                              [id]="'draft-desc-' + file.id"
                              [placeholder]="'wall.personal.work-description-placeholder' | translate"
                              (input)="resizeWorkField($event)"></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>

            <div class="personal-wall-publish-wrap">
              <button type="button" mat-stroked-button
                class="personal-wall-draft-cancel-btn rounded-pill fw-bold"
                [disabled]="isPublishing || isDraftCollapsing"
                (click)="cancelDraftShare()">
                {{ 'wall.personal.draft-cancel' | translate }}
              </button>
              <button type="button" mat-raised-button color="primary"
                class="personal-wall-publish-btn text-white rounded-pill fw-bold"
                [disabled]="!hasSelectedPages || isPublishing || isDraftCollapsing"
                (click)="publishWorks()">
                <span class="personal-wall-publish-btn-inner">
                  <mat-spinner *ngIf="isPublishing" diameter="20"></mat-spinner>
                  {{ publishButtonKey | translate }}
                </span>
              </button>
            </div>
            </div>
          </section>

          <!-- Shared / unshared / profile tabs -->
          <section class="personal-wall-panel personal-wall-works">
            <div class="personal-wall-works-tabs" role="tablist"
              [attr.aria-label]="'wall.personal.works-tabs' | translate">
              <button type="button"
                role="tab"
                class="personal-wall-works-tab"
                [class.is-active]="worksTab === 'published'"
                [attr.aria-selected]="worksTab === 'published'"
                (click)="setWorksTab('published')">
                <span class="personal-wall-works-tab-label">{{ 'wall.personal.published-title' | translate }}</span>
              </button>
              <button type="button"
                role="tab"
                class="personal-wall-works-tab"
                [class.is-active]="worksTab === 'unshared'"
                [attr.aria-selected]="worksTab === 'unshared'"
                (click)="setWorksTab('unshared')">
                <span class="personal-wall-works-tab-label">{{ 'wall.personal.unshared-title' | translate }}</span>
              </button>
              <button type="button"
                role="tab"
                class="personal-wall-works-tab"
                [class.is-active]="worksTab === 'profile'"
                [attr.aria-selected]="worksTab === 'profile'"
                (click)="setWorksTab('profile')">
                <span class="personal-wall-works-tab-label">{{ 'wall.personal.profile-title' | translate }}</span>
              </button>
            </div>

            <div *ngIf="worksTab === 'published' || (worksTab === 'unshared' && hasPendingUnsharedShareCard())"
              role="tabpanel"
              class="personal-wall-works-panel"
              [class.personal-wall-works-panel-pending-host]="worksTab === 'unshared' && hasPendingUnsharedShareCard()">
            <ng-container *ngIf="!isLoadingPublished || publishedItems.length || publishedSkeletonSlots.length">
              <div *ngIf="!isLoadingPublished && !publishedItems.length && !wallFiles.length" class="personal-wall-empty">
                <mat-icon>inventory_2</mat-icon>
                <b>{{ 'wall.personal.empty.works' | translate }}</b>
              </div>

              <div *ngIf="!isLoadingPublished && !publishedItems.length && wallFiles.length"
                class="personal-wall-empty personal-wall-empty-compact">
                <mat-icon>inventory_2</mat-icon>
                <span>{{ 'wall.personal.empty.published' | translate }}</span>
              </div>

              <div *ngIf="publishedItems.length || publishedSkeletonSlots.length"
                #publishedCollage
                class="personal-wall-collage personal-wall-rows-collage"
                [attr.aria-busy]="isLoadingPublished"
                [style.--gallery-gap.px]="publishedLayoutGap"
                [style.height.px]="publishedLayoutTotalHeight">
                <div class="personal-wall-row"
                  *ngFor="let row of publishedLayoutRows; trackBy: trackRow"
                  [style.top.px]="row.top"
                  [style.z-index]="commentsTargetId ? null : row.zIndex"
                  [style.height.px]="row.maxHeight"
                  [style.gap.px]="publishedLayoutGap">
                <article *ngFor="let layoutItem of row.items; trackBy: trackLayoutItem"
                  class="personal-wall-card personal-wall-card-published"
                  [attr.data-published-id]="layoutItem.work._id"
                  [class.personal-wall-card-skeleton]="isSkeletonWork(layoutItem.work)"
                  [class.personal-wall-card-slot-held]="!isSkeletonWork(layoutItem.work) && isPublishedFocus(layoutItem.work)"
                  [class.personal-wall-card-open]="!isSkeletonWork(layoutItem.work) && (layoutItem.work.commentsOpen || isPublishedEditFocus(layoutItem.work))"
                  [class.personal-wall-card-just-added]="!isSkeletonWork(layoutItem.work) && isJustAdded(layoutItem.work)"
                  [style.width.px]="layoutItem.width"
                  [style.flex]="'0 0 auto'"
                  [style.height.px]="isSkeletonWork(layoutItem.work) ? layoutItem.height : (publishedFocusSlotHeight(layoutItem.work) || layoutItem.height)">
                  <div *ngIf="isSkeletonWork(layoutItem.work)"
                    class="personal-wall-card-media is-loading"
                    [style.height.px]="layoutItem.height">
                    <div class="personal-wall-card-shimmer"></div>
                  </div>
                  <ng-container *ngIf="!isSkeletonWork(layoutItem.work) && layoutItem.work as item">
                  <div class="personal-wall-card-panel"
                    [attr.data-focus-panel]="item._id"
                    [class.personal-wall-card-focus]="isPublishedFocus(item)"
                    [class.personal-wall-card-focus-panoramic]="isPublishedFocus(item) && isFocusPanoramic(item)"
                    [class.personal-wall-card-focus-fill]="isFocusHeightCapped(item)"
                    [class.personal-wall-card-focus-open]="isPublishedFocus(item) && item.commentsOpen"
                    [class.personal-wall-card-focus-edit]="isPublishedEditFocus(item)"
                    [class.personal-wall-card-focus-pending-share]="isPendingUnsharedShare(item)">
                  <button *ngIf="isPublishedSocialFocus(item)"
                    type="button"
                    class="personal-wall-focus-edit-btn"
                    (click)="openPublishedEditFocus(item, $event)"
                    [matTooltip]="'wall.personal.edit-work' | translate"
                    matTooltipPosition="below"
                    [attr.aria-label]="'wall.personal.edit-work' | translate">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <app-wall-card-social #soc
                    [card]="item"
                    [siblingCards]="publishedItems"
                    [hideCommentCompose]="isPublishedEditFocus(item) || item.editingTitle || item.editingDescription"
                    [suppressComments]="isPublishedEditFocus(item)"
                    [focusLayout]="isPublishedFocus(item)"
                    [showAllComments]="isPublishedSocialFocus(item)"
                    [manageOpenExternally]="true"
                    [compactOverlay]="isPublishedCardNarrow(layoutItem.width)"
                    [showLikeCount]="showPublishedLikeCount(layoutItem.width)"
                    (openRequested)="togglePublishedFocus(item, $event)"
                    (commentsLayoutChange)="onPublishedCommentsLayout(item)">
                  <div wallMedia class="personal-wall-card-media"
                    [class.personal-wall-card-media-sized]="!!item.natW"
                    [class.is-loading]="!item.imgLoaded"
                    [style.height.px]="isPublishedFocus(item) ? null : layoutItem.height"
                    [style.aspect-ratio]="isPublishedFocus(item) ? mediaAspectRatio(item, item.draftRotation) : null"
                    [style.--focus-ar]="isPublishedFocus(item) ? mediaAspectValue(item) : null"
                    (click)="soc.openFromImage($event)">
                    <div class="personal-wall-card-media-clip">
                      <img [src]="publishedThumb(item)"
                        [alt]="item.draftTitle || item.title || ''"
                        class="personal-wall-card-img"
                        [class.personal-wall-card-img-fitted]="!!item.natW"
                        [class.personal-wall-card-img-sideways]="isSideways(item.draftRotation)"
                        [class.is-pending]="!item.imgLoaded"
                        [style.transform]="imageTransform(item.draftRotation)"
                        (load)="onWallImageLoad($event, item)"
                        (error)="onImageError($event, item)">
                    </div>
                    <div *ngIf="!item.imgLoaded" class="personal-wall-card-shimmer"></div>
                    <button *ngIf="item.hiddenFromAudience && !isPublishedFocus(item)"
                      type="button"
                      class="personal-wall-hidden-badge"
                      [class.is-narrow]="isPublishedCardNarrow(layoutItem.width)"
                      [disabled]="item.hiding || item.deleting"
                      (click)="toggleHiddenFromAudience(item, $event)"
                      [matTooltip]="'wall.personal.show-to-audience' | translate"
                      matTooltipPosition="below"
                      [attr.aria-label]="'wall.personal.show-to-audience' | translate">
                      <mat-icon>visibility_off</mat-icon>
                      <span class="personal-wall-hidden-badge-text">{{ 'wall.personal.hidden-badge' | translate }}</span>
                    </button>
                    <button *ngIf="item.imgLoaded && !isPublishedFocus(item) && !isPendingUnsharedShare(item)"
                      type="button"
                      class="personal-wall-media-edit-btn"
                      (click)="openPublishedEditFocus(item, $event)"
                      [matTooltip]="'wall.personal.edit-work' | translate"
                      matTooltipPosition="below"
                      [attr.aria-label]="'wall.personal.edit-work' | translate">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>

                  <div wallOwner (click)="$event.stopPropagation()">
                    <ng-container *ngIf="isPublishedEditFocus(item)">
                      <div class="personal-wall-edit-panel">
                        <div class="personal-wall-edit-action-group">
                          <button type="button" class="personal-wall-edit-action"
                            (click)="rotatePublishedClockwise(item, $event); $event.preventDefault()">
                            <mat-icon>rotate_right</mat-icon>
                            <span>{{ 'wall.personal.rotate' | translate }}</span>
                          </button>
                          <button type="button" class="personal-wall-edit-action"
                            [class.is-muted]="item.hiddenFromAudience"
                            [disabled]="!isPendingUnsharedShare(item) && (item.deleting || item.hiding)"
                            (click)="onEditHideFromAudienceClick(item, $event); $event.preventDefault()">
                            <mat-icon>{{ item.hiddenFromAudience ? 'visibility_off' : 'visibility' }}</mat-icon>
                            <span>{{ (item.hiddenFromAudience ? 'wall.personal.show-to-audience' : 'wall.personal.hide-from-audience') | translate }}</span>
                          </button>
                          <ng-container *ngIf="!isPendingUnsharedShare(item)">
                          <button type="button" class="personal-wall-edit-action is-danger"
                            [matMenuTriggerFor]="deleteWorkMenu"
                            [disabled]="item.deleting"
                            (click)="$event.stopPropagation()">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'wall.personal.delete-menu' | translate }}</span>
                          </button>
                          <mat-menu #deleteWorkMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item class="personal-wall-delete-menu-item"
                              [disabled]="item.deleting"
                              (click)="deletePublishedWork(item, $event)">
                              <mat-icon>delete_forever</mat-icon>
                              <span>{{ 'wall.personal.delete-from-wall' | translate }}</span>
                            </button>
                          </mat-menu>
                          </ng-container>
                        </div>

                        <div class="personal-wall-edit-fields">
                          <div class="personal-wall-edit-field">
                            <label class="personal-wall-edit-field-label"
                              [attr.for]="'work-title-' + item._id">
                              {{ 'wall.personal.work-title' | translate }}
                            </label>
                            <mat-form-field appearance="outline" subscriptSizing="dynamic"
                              class="w-100 eazix-exhibition-comment-field personal-wall-edit-comment-field">
                              <textarea matInput rows="1" [(ngModel)]="item.draftTitle"
                                [id]="'work-title-' + item._id"
                                [placeholder]="'wall.personal.work-title-placeholder' | translate"
                                [attr.data-work-title]="item._id"
                                (input)="onPublishedEditFieldInput(item, $event)"></textarea>
                            </mat-form-field>
                          </div>

                          <div class="personal-wall-edit-field">
                            <label class="personal-wall-edit-field-label"
                              [attr.for]="'work-desc-' + item._id">
                              {{ 'wall.personal.work-description' | translate }}
                            </label>
                            <mat-form-field appearance="outline" subscriptSizing="dynamic"
                              class="w-100 eazix-exhibition-comment-field personal-wall-edit-comment-field">
                              <textarea matInput rows="1" [(ngModel)]="item.draftDescription"
                                [id]="'work-desc-' + item._id"
                                [placeholder]="'wall.personal.work-description-placeholder' | translate"
                                [attr.data-work-desc]="item._id"
                                (input)="onPublishedEditFieldInput(item, $event)"></textarea>
                            </mat-form-field>
                          </div>

                          <div *ngIf="isPendingUnsharedShare(item)" class="personal-wall-save-wrap personal-wall-pending-share-actions">
                            <button type="button"
                              class="rounded-pill personal-wall-edit-share-btn"
                              [disabled]="isPendingShareSubmitting(item)"
                              (click)="confirmPendingUnsharedShare(item)">
                              <mat-spinner *ngIf="isPendingShareSubmitting(item)" diameter="18"></mat-spinner>
                              <span>{{ (isPendingShareSubmitting(item) ? 'wall.personal.share-work-loading' : 'wall.personal.share-work-action') | translate }}</span>
                            </button>
                            <button type="button"
                              class="personal-wall-edit-cancel-btn"
                              [disabled]="isPendingShareSubmitting(item)"
                              (click)="cancelPendingUnsharedShareClick(item, $event)">
                              <span>{{ 'wall.personal.draft-cancel' | translate }}</span>
                            </button>
                          </div>
                          <div *ngIf="!isPendingUnsharedShare(item) && isPublishedDirty(item)" class="personal-wall-save-wrap">
                            <button type="button" mat-button color="primary"
                              class="rounded-pill eazix-exhibition-send-comment-btn personal-wall-edit-save-btn"
                              [attr.data-edit-save]="item._id"
                              [disabled]="isPublishedSaving(item)"
                              (click)="saveAllPublishedChanges(item)">
                              {{ (isPublishedSaving(item) ? 'wall.personal.save-loading' : 'wall.personal.save-changes') | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="isPublishedSocialFocus(item)">
                    <div *ngIf="item.draftTitle" class="personal-wall-text-row"
                      [class.has-expanded-text]="item.workTitleExpanded">
                      <b class="personal-wall-published-title"
                        [class.is-expanded]="item.workTitleExpanded"
                        [wallLineOverflow]="!item.workTitleExpanded"
                        (wallLineOverflowing)="onWorkTitleOverflow(item, $event)"
                        [attr.title]="item.draftTitle">
                        {{ displayWorkText(item.draftTitle) }}
                      </b>
                      <button *ngIf="item.workTitleOverflow"
                        type="button"
                        class="personal-wall-work-text-toggle"
                        [class.is-open]="item.workTitleExpanded"
                        (click)="toggleWorkText(item, 'title', $event)">
                        {{ (item.workTitleExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
                      </button>
                    </div>

                    <div *ngIf="item.draftDescription" class="personal-wall-text-row"
                      [class.has-expanded-text]="item.workDescExpanded">
                      <p class="personal-wall-published-desc mb-0"
                        [class.is-expanded]="item.workDescExpanded"
                        [wallLineOverflow]="!item.workDescExpanded"
                        (wallLineOverflowing)="onWorkDescOverflow(item, $event)"
                        [attr.title]="item.draftDescription">
                        {{ displayWorkText(item.draftDescription) }}
                      </p>
                      <button *ngIf="item.workDescOverflow"
                        type="button"
                        class="personal-wall-work-text-toggle"
                        [class.is-open]="item.workDescExpanded"
                        (click)="toggleWorkText(item, 'description', $event)">
                        {{ (item.workDescExpanded ? 'wall.exhibition.less' : 'wall.exhibition.more') | translate }}
                      </button>
                    </div>
                    </ng-container>
                  </div>
                  </app-wall-card-social>
                  </div>
                  </ng-container>
                </article>
                </div>
              </div>

              <div *ngIf="publishedHasMore"
                class="personal-wall-unshared-sentinel-wrap"
                aria-hidden="true">
                <div #publishedSentinel class="personal-wall-unshared-sentinel"></div>
              </div>
            </ng-container>
            </div>

            <div *ngIf="worksTab === 'unshared'" role="tabpanel" class="personal-wall-works-panel personal-wall-unshared">
              <ng-container *ngIf="!isLoadingUnshared || unsharedHasMore">
                <div *ngIf="!isLoadingUnshared && !unsharedItems.length && !unsharedHasMore && !unsharedLoadError"
                  class="personal-wall-empty personal-wall-empty-compact">
                  <mat-icon>visibility_off</mat-icon>
                  <span>{{ 'wall.personal.unshared-empty' | translate }}</span>
                </div>

                <div *ngIf="!isLoadingUnshared && unsharedLoadError && !unsharedItems.length"
                  class="personal-wall-empty personal-wall-empty-compact">
                  <mat-icon>error_outline</mat-icon>
                  <span>{{ 'wall.personal.unshared-error' | translate }}</span>
                </div>

                <div *ngIf="isLoadingUnshared || unsharedItems.length || unsharedHasMore || unsharedSkeletonSlots.length"
                  #unsharedCollage
                  class="personal-wall-collage personal-wall-rows-collage"
                  [attr.aria-busy]="isLoadingUnshared || isLoadingMoreUnshared"
                  [style.--gallery-gap.px]="unsharedLayoutGap"
                  [style.height.px]="unsharedLayoutTotalHeight || null">
                  <div class="personal-wall-row"
                    *ngFor="let row of unsharedLayoutRows; trackBy: trackRow"
                    [style.top.px]="row.top"
                    [style.z-index]="row.zIndex"
                    [style.height.px]="row.maxHeight"
                    [style.gap.px]="unsharedLayoutGap">
                    <article *ngFor="let layoutItem of row.items; trackBy: trackLayoutItem"
                      class="personal-wall-card personal-wall-card-unshared"
                      [attr.data-unshared-id]="layoutItem.work._id || layoutItem.work.id"
                      [class.personal-wall-card-skeleton]="isSkeletonWork(layoutItem.work)"
                      [class.personal-wall-card-slot-held]="!isSkeletonWork(layoutItem.work) && isUnsharedPendingShareSlot(layoutItem.work)"
                      [style.width.px]="layoutItem.width"
                      [style.height.px]="isSkeletonWork(layoutItem.work) || isUnsharedPendingShareSlot(layoutItem.work) ? layoutItem.height : null"
                      [style.flex]="'0 0 auto'">
                      <div *ngIf="isSkeletonWork(layoutItem.work)"
                        class="personal-wall-card-media is-loading"
                        [style.height.px]="layoutItem.height">
                        <div class="personal-wall-card-shimmer"></div>
                      </div>
                      <ng-container *ngIf="!isSkeletonWork(layoutItem.work) && layoutItem.work as item">
                      <div class="personal-wall-card-media"
                        [class.personal-wall-card-media-sized]="!!item.natW"
                        [class.is-loading]="!item.imgLoaded"
                        [style.height.px]="layoutItem.height"
                        (click)="shareUnsharedWork(item, $event)">
                        <div class="personal-wall-card-media-clip">
                          <img [src]="item.thumbUrl"
                            [alt]="item.fileName || ''"
                            class="personal-wall-card-img"
                            [class.personal-wall-card-img-fitted]="!!item.natW"
                            [class.is-pending]="!item.imgLoaded"
                            (load)="onUnsharedImageLoad($event, item)"
                            (error)="onUnsharedImageError($event, item)">
                        </div>
                        <div *ngIf="!item.imgLoaded" class="personal-wall-card-shimmer"></div>
                        <button *ngIf="!isUnsharedPendingShareSlot(item)"
                          type="button"
                          class="personal-wall-unshared-share-btn"
                          [disabled]="item.sharing"
                          (click)="shareUnsharedWork(item, $event)">
                          <mat-spinner *ngIf="item.sharing" diameter="12"></mat-spinner>
                          <span *ngIf="!item.sharing">{{ 'wall.personal.share-work' | translate }}</span>
                        </button>
                      </div>
                      </ng-container>
                    </article>
                  </div>
                </div>

                <div *ngIf="unsharedHasMore"
                  class="personal-wall-unshared-sentinel-wrap"
                  aria-hidden="true">
                  <div #unsharedSentinel class="personal-wall-unshared-sentinel"></div>
                </div>

                <div *ngIf="!isLoadingUnshared && !isLoadingMoreUnshared && unsharedItems.length && !unsharedHasMore"
                  class="personal-wall-unshared-end">
                  {{ 'wall.personal.unshared-end' | translate }}
                </div>
              </ng-container>
            </div>

            <div *ngIf="worksTab === 'profile'"
              role="tabpanel"
              class="personal-wall-works-panel personal-wall-profile-panel">
              <section class="personal-wall-side-card personal-wall-profile-hero">
                <div class="personal-wall-profile-hero-main">
                  <div class="personal-wall-profile-hero-info">
                    <div class="personal-wall-user-name-row">
                      <ng-container *ngIf="!editingName">
                        <h2 class="personal-wall-user-name mb-0 text-truncate">
                          {{ userName || ('wall.personal.anonymous' | translate) }}
                        </h2>
                        <button type="button"
                          class="personal-wall-icon-btn"
                          [disabled]="savingProfile"
                          (click)="startEditName($event)"
                          [matTooltip]="'wall.personal.edit-profile' | translate"
                          matTooltipPosition="above"
                          [attr.aria-label]="'wall.personal.edit-profile' | translate">
                          <mat-icon>edit</mat-icon>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="editingName">
                        <div class="personal-wall-edit-field-row w-100">
                          <mat-form-field appearance="outline" class="w-100 personal-wall-field personal-wall-name-field">
                            <mat-label>{{ 'my-profile.username' | translate }}</mat-label>
                            <input matInput
                              [(ngModel)]="draftName"
                              maxlength="40"
                              [disabled]="savingProfile">
                          </mat-form-field>
                          <button type="button"
                            class="personal-wall-icon-btn"
                            (click)="cancelEditName($event)"
                            [matTooltip]="'wall.personal.cancel-edit' | translate"
                            matTooltipPosition="above"
                            [attr.aria-label]="'wall.personal.cancel-edit' | translate">
                            <mat-icon>edit_off</mat-icon>
                          </button>
                        </div>
                      </ng-container>
                    </div>
                    <div *ngIf="editingName && !isNameValid()" class="personal-wall-name-error mb-2">
                      {{ 'my-profile.username.error' | translate }}
                    </div>

                    <div class="personal-wall-academy">
                      <ng-container *ngIf="!editingAcademy">
                        <div class="personal-wall-academy-view">
                          <div class="personal-wall-academy-identity min-w-0">
                            <img *ngIf="academyDisplayName(academySerialName)"
                              class="personal-wall-academy-logo"
                              [src]="academyLogoUrl(academySerialName)"
                              alt=""
                              (error)="onAcademyLogoError($event)">
                            <span class="personal-wall-academy-name text-truncate"
                              [class.personal-wall-academy-placeholder]="!academyDisplayName(academySerialName)">
                              <ng-container *ngIf="academyDisplayName(academySerialName); else academyPlaceholder">
                                {{ academyDisplayName(academySerialName) }}
                              </ng-container>
                              <ng-template #academyPlaceholder>
                                {{ 'wall.personal.academy-placeholder' | translate }}
                              </ng-template>
                            </span>
                          </div>
                          <button type="button"
                            class="personal-wall-icon-btn"
                            [disabled]="savingAcademy"
                            (click)="startEditAcademy()"
                            [matTooltip]="'wall.personal.edit-academy' | translate"
                            matTooltipPosition="above"
                            [attr.aria-label]="'wall.personal.edit-academy' | translate">
                            <mat-icon>edit</mat-icon>
                          </button>
                        </div>
                      </ng-container>

                      <div *ngIf="editingAcademy" class="personal-wall-edit-field-row">
                        <mat-form-field
                          appearance="outline"
                          class="w-100 personal-wall-field personal-wall-academy-field">
                          <mat-label>{{ 'wall.personal.academy' | translate }}</mat-label>
                          <mat-select
                            #academySelect
                            [ngModel]="academySerialName"
                            [disabled]="savingAcademy"
                            (ngModelChange)="onAcademyChange($event)"
                            (openedChange)="onAcademyPanelOpenedChange($event)">
                            <mat-select-trigger>
                              <span class="personal-wall-academy-option" *ngIf="academySerialName">
                                <img class="personal-wall-academy-logo"
                                  [src]="academyLogoUrl(academySerialName)"
                                  alt=""
                                  (error)="onAcademyLogoError($event)">
                                <span>{{ academyDisplayName(academySerialName) }}</span>
                              </span>
                              <span *ngIf="!academySerialName">{{ 'wall.personal.academy-placeholder' | translate }}</span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let opt of academyOptions" [value]="opt.serialName">
                              <span class="personal-wall-academy-option">
                                <img class="personal-wall-academy-logo"
                                  [src]="academyLogoUrl(opt.serialName)"
                                  alt=""
                                  (error)="onAcademyLogoError($event)">
                                <span>{{ opt.labelKey | translate }}</span>
                              </span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <button type="button"
                          class="personal-wall-icon-btn"
                          [disabled]="savingAcademy"
                          (click)="cancelEditAcademy($event)"
                          [matTooltip]="'wall.personal.cancel-edit' | translate"
                          matTooltipPosition="above"
                          [attr.aria-label]="'wall.personal.cancel-edit' | translate">
                          <mat-icon>edit_off</mat-icon>
                        </button>
                      </div>
                    </div>

                    <div class="personal-wall-about">
                      <div class="personal-wall-about-row">
                        <div class="personal-wall-about-body min-w-0">
                          <ng-container *ngIf="!isAboutInEditMode()">
                            <p class="personal-wall-about-text mb-0">{{ (baselineAbout || '').trim() }}</p>
                          </ng-container>

                          <ng-container *ngIf="isAboutInEditMode()">
                            <div class="personal-wall-edit-field-row">
                              <mat-form-field appearance="outline" class="w-100 personal-wall-field personal-wall-about-field">
                                <mat-label>{{ 'wall.personal.about' | translate }}</mat-label>
                                <textarea matInput rows="3" [(ngModel)]="draftAbout"></textarea>
                              </mat-form-field>
                              <button *ngIf="hasSavedAbout()" type="button"
                                class="personal-wall-icon-btn personal-wall-trash-btn"
                                (click)="clearAbout($event)"
                                [attr.aria-label]="'wall.personal.clear-about' | translate">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </ng-container>
                        </div>

                        <button *ngIf="hasSavedAbout() && !editingAbout" type="button"
                          class="personal-wall-icon-btn"
                          (click)="startEditAbout($event)"
                          [matTooltip]="'wall.personal.edit-about' | translate"
                          matTooltipPosition="above"
                          [attr.aria-label]="'wall.personal.edit-about' | translate">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="hasSavedAbout() && editingAbout" type="button"
                          class="personal-wall-icon-btn"
                          (click)="cancelEditAbout($event)"
                          [matTooltip]="'wall.personal.cancel-edit' | translate"
                          matTooltipPosition="above"
                          [attr.aria-label]="'wall.personal.cancel-edit' | translate">
                          <mat-icon>edit_off</mat-icon>
                        </button>
                      </div>

                      <div *ngIf="isProfileDirty()" class="personal-wall-about-save mt-2">
                        <button type="button" mat-stroked-button color="primary"
                          class="rounded-pill w-100 personal-wall-save-btn"
                          [disabled]="savingProfile || (isNameDirty() && !isNameValid())"
                          (click)="saveProfile()">
                          {{ (savingProfile ? 'wall.personal.save-profile-loading' : 'wall.personal.save-profile') | translate }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="personal-wall-profile-hero-aside">
                    <div class="personal-wall-avatar">
                      <img *ngIf="userProfileImg" [src]="userProfileImg" alt=""
                        referrerpolicy="no-referrer"
                        (error)="onProfileImageError()">
                      <span *ngIf="!userProfileImg">{{ (userName || '?').charAt(0) }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <section class="personal-wall-side-card personal-wall-profile-settings">
                <h3 class="personal-wall-side-title">{{ 'wall.personal.status.title' | translate }}</h3>
                <div class="personal-wall-setting-row">
                  <div class="personal-wall-setting-copy">
                    <div class="personal-wall-setting-label">
                      <mat-icon class="personal-wall-status-icon">work_outline</mat-icon>
                      <span>{{ 'wall.personal.status.looking' | translate }}</span>
                    </div>
                    <p class="personal-wall-setting-hint mb-0">{{ 'wall.personal.status.looking-hint' | translate }}</p>
                  </div>
                  <mat-slide-toggle color="primary"
                    [checked]="lookingForWork"
                    [disabled]="savingStatus"
                    (change)="onLookingForWorkChange($event.checked)">
                  </mat-slide-toggle>
                </div>
                <div class="personal-wall-setting-row">
                  <div class="personal-wall-setting-copy">
                    <div class="personal-wall-setting-label">
                      <mat-icon class="personal-wall-status-icon">groups</mat-icon>
                      <span>{{ 'wall.personal.status.helping' | translate }}</span>
                    </div>
                    <p class="personal-wall-setting-hint mb-0">{{ 'wall.personal.status.helping-hint' | translate }}</p>
                  </div>
                  <mat-slide-toggle color="primary"
                    [checked]="offeringHelp"
                    [disabled]="savingStatus"
                    (change)="onOfferingHelpChange($event.checked)">
                  </mat-slide-toggle>
                </div>
                <div class="personal-wall-setting-row">
                  <div class="personal-wall-setting-copy">
                    <div class="personal-wall-setting-label">
                      <mat-icon class="personal-wall-status-icon">mail_outline</mat-icon>
                      <span>{{ 'wall.personal.status.contact' | translate }}</span>
                    </div>
                    <p class="personal-wall-setting-hint mb-0">{{ 'wall.personal.status.contact-hint' | translate }}</p>
                  </div>
                  <mat-slide-toggle
                    #allowContactTip="matTooltip"
                    color="primary"
                    [checked]="allowContact"
                    [disabled]="savingStatus"
                    [matTooltip]="'wall.personal.status.contact-locked' | translate"
                    matTooltipPosition="below"
                    matTooltipClass="personal-wall-contact-tip"
                    [matTooltipDisabled]="!showContactLockedTip"
                    matTooltipShowDelay="0"
                    matTooltipHideDelay="5500"
                    matTooltipTouchGestures="off"
                    (change)="onAllowContactChange($event, allowContactTip)">
                  </mat-slide-toggle>
                </div>
              </section>
            </div>
          </section>
      </main>
    </div>
  </div>
  <div *ngIf="!isLoading && !isLoadingPublished && !isPublishing"
    class="personal-wall-new-order-bar">
    <button type="button"
      class="w-100 rounded-pill fw-bold text-white zx-small-btn"
      mat-raised-button
      color="primary"
      (click)="goToNewOrder()">
      {{ 'main-nav.new-order' | translate }}
    </button>
  </div>
  <div class="personal-wall-focus-backdrop"
    *ngIf="commentsTargetId"
    [class.is-visible]="isFocusCloseVisible()"
    (click)="closeActivePublishedFocus()"
    aria-hidden="true"></div>
  <button *ngIf="isFocusCloseVisible()"
    type="button"
    class="personal-wall-focus-close"
    (pointerdown)="$event.stopPropagation()"
    (click)="onFocusCloseClick($event)"
    [attr.aria-label]="'close-branch.btn' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>
